const coursetype = {
    state: {
      addCourseTypeDialog: {
        title: '新增课程类型信息',
        type: 'add'
      },
      appointmentTypeList: [],
      courseSearchBtnDisabled: true
    },
    getters: {
      addCourseTypeDialog: state => state.addCourseTypeDialog,
      courseSearchBtnDisabled: state => state.courseSearchBtnDisabled,
      appointmentTypeList: state => state.appointmentTypeList
    },
    mutations: {
      SET_COURSETYPE_DIALOG_TITLE: (state, type) => {
        console.log("SET_COURSETYPE_DIALOG_TITLE");
        if (type === 'add') {
          state.addCourseTypeDialog.title = '新增课程类型信息'
          state.addCourseTypeDialog.type = 'add'
        } else {
          state.addCourseTypeDialog.title = '编辑课程类型信息'
          state.addCourseTypeDialog.type = 'edit'
        }
      },
      SET_COURSE_SEARCHBTN_DISABLED: (state, payload) => {
        state.courseSearchBtnDisabled = payload;
      },
      SET_APPOINTMENT_TYPE_LIST: (state, payload) => {
        state.appointmentTypeList = payload;
      }
    },
    actions: {
  
    }
  }
  
  export default coursetype